import React from "react"
import PropTypes from "prop-types"
import Styled from "styled-components"
// Spacing
import {spacing} from "@uprise/spacing"

const SpacerWrapper = Styled.div`
     margin-top: ${props => (props.marginTop ? spacing[props.marginTop] : 0)};
     margin-right: ${props =>
			props.marginRight ? spacing[props.marginRight] : 0};
     margin-bottom: ${props =>
			props.marginBottom ? spacing[props.marginBottom] : 0};
     margin-left: ${props =>
			props.marginLeft ? spacing[props.marginLeft] : 0};
`

function Spacer({marginTop, marginBottom, marginRight, marginLeft}) {
	return (
		<SpacerWrapper
			marginTop={marginTop}
			marginBottom={marginBottom}
			marginRight={marginRight}
			marginLeft={marginLeft}></SpacerWrapper>
	)
}

export default Spacer

Spacer.propTypes = {}
Spacer.defaultProps = {}
